/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueveryweek2Inputs */

const en_menueveryweek2 = /** @type {(inputs: Menueveryweek2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Same every week`)
};

const de_menueveryweek2 = /** @type {(inputs: Menueveryweek2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Woche gleich`)
};

/**
* | output |
* | --- |
* | "Same every week" |
*
* @param {Menueveryweek2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueveryweek2 = /** @type {((inputs?: Menueveryweek2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueveryweek2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueveryweek2(inputs)
	return de_menueveryweek2(inputs)
});
export { menueveryweek2 as "menuEveryWeek" }